import React from 'react';
import Flatpickr from 'react-flatpickr';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import dayjs from 'dayjs';

interface DateInputProps {
  id?: string;
  className?: string;
  placeholder?: string;
  value?: string | Date;
  onChange: (date: string) => void;
  error?: string;
  enableTime?: boolean;
  disabled?: boolean;
  minDate?: string | Date;
}

const DateInput: React.FC<DateInputProps> = ({
  id,
  className = 'form-control',
  placeholder,
  value,
  onChange,
  error,
  enableTime = false,
  disabled = false,
  minDate,
}) => {
  const dateFormat = enableTime ? 'd/m/Y H:i' : 'd/m/Y';
  const placeholderText = placeholder || (enableTime ? 'dd/mm/aaaa HH:mm' : 'dd/mm/aaaa');

  const handleChange = (selectedDates: Date[]) => {
    if (selectedDates[0]) {
      if (enableTime) {
        onChange(dayjs(selectedDates[0]).format('YYYY-MM-DDTHH:mm:ss'));
      } else {
        onChange(dayjs(selectedDates[0]).format('YYYY-MM-DD'));
      }
    } else {
      onChange('');
    }
  };

  return (
    <div>
      <div className="position-relative">
        <Flatpickr
          className={`${className} ${error ? 'is-invalid' : ''}`}
          disabled={disabled}
          id={id}
          options={{
            enableTime,
            dateFormat,
            locale: Portuguese,
            allowInput: true,
            time_24hr: true,
            minDate: minDate ? dayjs(minDate).toDate() : undefined,
          }}
          placeholder={placeholderText}
          value={value ? dayjs(value).toDate() : undefined}
          onChange={handleChange}
          onClose={handleChange}
        />
        <span
          className="position-absolute top-50 end-0 translate-middle-y me-3 d-flex align-items-center"
          style={{ pointerEvents: 'none' }}
        >
          <i className="ki-duotone ki-calendar fs-2">
            <span className="path1" />
            <span className="path2" />
          </i>
        </span>
      </div>
      {error ? (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">{error}</div>
        </div>
      ) : null}
    </div>
  );
};

export default DateInput;
